module.exports = (parcelRequire.load("6ZmbR")).then(() => parcelRequire('80thX'));